import { Container, Nav, Navbar, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const NavigationBarComp = () => {
    const navigate = useNavigate();

    return (
        <div>
            <Navbar expand="lg" className="bg-body-tertiary shadow-sm myNavbar" fixed="top">
                <Container>
                    <Navbar.Brand>
                        <Nav.Link onClick={() => navigate('/')}>The One Shop</Nav.Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Stack gap={2}>
                            <Nav className="ms-auto text-end">
                                <Nav.Link onClick={() => navigate('/')}>Home</Nav.Link>
                                <Nav.Link onClick={() => navigate('/about')}>About</Nav.Link>
                            </Nav>
                        </Stack>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default NavigationBarComp;
